// import React, { useState, useEffect } from "react";
// import {
//   FaHeart,
//   FaCalendarAlt,
//   FaUserAlt,
//   FaSearch,
//   FaArrowRight,
// } from "react-icons/fa";
// import { GiOpenBook, GiHeartInside,GiMagnifyingGlass,GiLoveMystery } from "react-icons/gi";
// import "./BlogsPage.css";

// const BlogsPage = () => {
//   const [searchTerm, setSearchTerm] = useState("");
//   const [currentSlide, setCurrentSlide] = useState(0);

//   const featuredBlogs = [
//     {
//       id: 1,
//       title: "How We Met Through Matrimony – A Modern Love Story",
//       image: "https://images.unsplash.com/photo-1517841905240-472988babdf9?auto=format&fit=crop&w=1200&q=80",
//       date: "September 15, 2025",
//       author: "Anjali & Rakesh",
//     },
//     {
//       id: 2,
//       title: "Virtual Meetings to Real-Life Weddings – Our Story!",
//       image: "https://images.unsplash.com/photo-1529626455594-4ff0802cfb7e?auto=format&fit=crop&w=1200&q=80",
//       date: "August 29, 2025",
//       author: "Sneha & Arjun",
//     },
//     {
//       id: 3,
//       title: "Creating Strong Bonds Through Trust and Respect",
//       image: "https://images.unsplash.com/photo-1521335629791-ce4aec67dd47?auto=format&fit=crop&w=1200&q=80",
//       date: "July 5, 2025",
//       author: "Kavya & Arvind",
//     },
//   ];

//   const sideBlogs = [
//     {
//       id: 4,
//       title: "Tips for Creating the Perfect Matrimony Profile",
//       image: "https://images.unsplash.com/photo-1520813792240-56fc4a3765a7?auto=format&fit=crop&w=600&q=80",
//       date: "October 3, 2025",
//       author: "Priya Sharma",
//     },
//     {
//       id: 5,
//       title: "The Role of Family in Matrimonial Decisions",
//       image: "https://images.unsplash.com/photo-1531746790731-6c087fecd65a?auto=format&fit=crop&w=600&q=80",
//       date: "October 20, 2025",
//       author: "Rahul Mehta",
//     },
//     {
//       id: 6,
//       title: "Building Compatibility Beyond Interests",
//       image: "https://images.unsplash.com/photo-1542317854-7ff8c1e5dfaa?auto=format&fit=crop&w=600&q=80",
//       date: "September 5, 2025",
//       author: "Rohit & Meena",
//     },
//     {
//       id: 7,
//       title: "Understanding Emotional Connection in Marriage",
//       image: "https://images.unsplash.com/photo-1517841905240-472988babdf9?auto=format&fit=crop&w=600&q=80",
//       date: "August 1, 2025",
//       author: "Aisha & Karan",
//     },
//   ];

//   const blogList = [
//     {
//       id: 8,
//       title: "How Trust Builds a Happy Marriage",
//       content:
//         "A successful marriage relies heavily on trust and mutual understanding. Couples who communicate openly and honestly develop deeper emotional bonds that last a lifetime.",
//       image: "https://images.unsplash.com/photo-1529626455594-4ff0802cfb7e?auto=format&fit=crop&w=900&q=80",
//       date: "July 12, 2025",
//       author: "Nisha & Raj",
//     },
//     {
//       id: 9,
//       title: "Love Beyond Borders – A Global Matrimony Story",
//       content:
//         "They met online across countries but love knows no boundaries. From different cultures and traditions, they created a unique story of togetherness.",
//       image: "https://images.unsplash.com/photo-1521335629791-ce4aec67dd47?auto=format&fit=crop&w=900&q=80",
//       date: "June 20, 2025",
//       author: "Sara & Ahmed",
//     },
//   ];

//   const missedBlogs = [
//     {
//       id: 10,
//       title: "Managing Expectations in Modern Relationships",
//       image: "https://images.unsplash.com/photo-1529333166437-7750a6dd5a70?auto=format&fit=crop&w=800&q=80",
//       date: "May 10, 2025",
//       author: "Neha & Vikram",
//     },
//     {
//       id: 11,
//       title: "Cultural Differences and Love Success",
//       image: "https://images.unsplash.com/photo-1506744038136-46273834b3fb?auto=format&fit=crop&w=800&q=80",
//       date: "April 2, 2025",
//       author: "Ankit & Lisa",
//     },
//     {
//       id: 12,
//       title: "Why Communication Matters Most",
//       image: "https://images.unsplash.com/photo-1529626455594-4ff0802cfb7e?auto=format&fit=crop&w=800&q=80",
//       date: "March 15, 2025",
//       author: "Deepa & Arun",
//     },
//     {
//       id: 13,
//       title: "From Friendship to Marriage – A Journey of Love",
//       image: "https://images.unsplash.com/photo-1531746790731-6c087fecd65a?auto=format&fit=crop&w=800&q=80",
//       date: "February 10, 2025",
//       author: "Meera & Vishal",
//     },
//   ];

//   useEffect(() => {
//     const interval = setInterval(() => {
//       setCurrentSlide((prev) => (prev + 1) % featuredBlogs.length);
//     }, 4500);
//     return () => clearInterval(interval);
//   }, [featuredBlogs.length]);

//   const filteredBlogs = blogList.filter((b) =>
//     b.title.toLowerCase().includes(searchTerm.toLowerCase())
//   );

//   return (
//     <div className="blogs-wrap31">
//       <div className="blogs-container31">
//         <div className="header-container31">
//         <div className="title-section31">
//           <h1 className="welcome31">
//             <GiHeartInside className="icon31" /> Welcome to Matrimony Blogs
//           </h1>
//           <p className="subtitle31">
//             Discover inspiring love stories, wedding journeys, and relationship insights.
//           </p>
//         </div>

//         <div className="search-bar31">
//           <GiMagnifyingGlass className="search-icon31" />
//           <input
//             type="text"
//             placeholder="Search..."
//             value={searchTerm}
//             onChange={(e) => setSearchTerm(e.target.value)}
//           />
//         </div>
//       </div>

//         {/* Featured + Side */}
//         <section className="featured-wrap31" aria-label="Featured blogs">
//           <div className="featured-left31">
//             <div className="featured-media31">
//               <img
//                 src={featuredBlogs[currentSlide].image}
//                 alt={featuredBlogs[currentSlide].title}
//                 className="featured-image31"
//               />
//             </div>
//             <div className="featured-text31">
//               <h2 className="featured-title31">
//                 {featuredBlogs[currentSlide].title}
//               </h2>
//               <p className="featured-meta31">
//                 <FaCalendarAlt className="meta-icon31" />{" "}
//                 {featuredBlogs[currentSlide].date} &nbsp; | &nbsp;
//                 <FaUserAlt className="meta-icon31" />{" "}
//                 {featuredBlogs[currentSlide].author}
//               </p>
//             </div>
//           </div>

//           <aside className="featured-right31" aria-label="Other highlights">
//             <div className="right-cards31">
//               {sideBlogs.map((b) => (
//                 <article key={b.id} className="small-card31" tabIndex="0">
//                   <img src={b.image} alt={b.title} />
//                   <div className="small-card-body31">
//                     <h4>{b.title}</h4>
//                     <p className="meta31">
//                       <FaCalendarAlt className="meta-icon31" /> {b.date}
//                       <br />
//                       <FaUserAlt className="meta-icon31" /> {b.author}
//                     </p>
//                   </div>
//                 </article>
//               ))}
//             </div>
//           </aside>
//         </section>

//         {/* Blog list */}
//         <section className="blog-list-wrap31">
//           {filteredBlogs.map((blog) => (
//             <article key={blog.id} className="blog-item31">
//               <img src={blog.image} alt={blog.title} className="blog-thumb31" />
//               <div className="blog-info31">
//                 <h3>{blog.title}</h3>
//                 <p className="meta31">
//                   <FaCalendarAlt className="meta-icon31" /> {blog.date} &nbsp; |{" "}
//                   &nbsp; <FaUserAlt className="meta-icon31" /> {blog.author}
//                 </p>
//                 <p className="content31">{blog.content}</p>
//                 <a href="#" className="readmore31">
//                   Read More <FaArrowRight className="arrow-icon31" />
//                 </a>
//               </div>
//             </article>
//           ))}
//         </section>

//         {/* You May Have Missed */}
//         <section className="missed-section31" aria-label="You may have missed">
//           <h2 className="missed-title31">
//             <GiLoveMystery className="icon-love31" /> You May Have Missed
//           </h2>
//           <div className="missed-scroll31">
//             {missedBlogs.map((m) => (
//               <article key={m.id} className="missed-card31" tabIndex="0">
//                 <img src={m.image} alt={m.title} />
//                 <div className="missed-info31">
//                   <h4>{m.title}</h4>
//                   <p className="meta31">
//                     <FaCalendarAlt className="meta-icon31" /> {m.date} &nbsp; |{" "}
//                     &nbsp; <FaUserAlt className="meta-icon31" /> {m.author}
//                   </p>
//                 </div>
//               </article>
//             ))}
//           </div>
//         </section>
//       </div>
//     </div>
//   );
// };

// export default BlogsPage;

import React, { useState, useEffect } from "react";
import axios from "axios";
import { FaCalendarAlt, FaUserAlt, FaArrowRight } from "react-icons/fa";
import { GiHeartInside, GiMagnifyingGlass, GiLoveMystery } from "react-icons/gi";
import "./BlogsPage.css";
import { Helmet } from "react-helmet";

const BlogsPage = () => {
  const [searchTerm, setSearchTerm] = useState("");
  const [currentSlide, setCurrentSlide] = useState(0);
  const [featuredBlogs, setFeaturedBlogs] = useState([]);
  const [sideBlogs, setSideBlogs] = useState([]);
  const [blogList, setBlogList] = useState([]);
  const [missedBlogs, setMissedBlogs] = useState([]);

  // Helper: safely handle base64 images
  const getImageSrc = (image) => {
    if (!image) return "";
    // Check if already includes "data:image/"
    return image.startsWith("data:image") ? image : `data:image/jpeg;base64,${image}`;
  };

  // Fetch blogs
  const fetchBlogs = async () => {
    try {
      const [resFeatured, resSide, resMain, resMissed] = await Promise.all([
        axios.get("https://back.varankal.com/api/blogs?type=featured"),
        axios.get("https://back.varankal.com/api/blogs?type=side"),
        axios.get("https://back.varankal.com/api/blogs?type=main"),
        axios.get("https://back.varankal.com/api/blogs?type=missed"),
      ]);

      setFeaturedBlogs(resFeatured.data);
      setSideBlogs(resSide.data);
      setBlogList(resMain.data);
      setMissedBlogs(resMissed.data);
    } catch (err) {
      console.error("Error fetching blogs:", err);
    }
  };

  useEffect(() => {
    fetchBlogs();
  }, []);

  // Auto-refresh every 5s
  useEffect(() => {
    const interval = setInterval(() => {
      fetchBlogs();
    }, 5000);
    return () => clearInterval(interval);
  }, []);

  // Auto-slide featured blogs
  useEffect(() => {
    if (featuredBlogs.length === 0) return;
    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % featuredBlogs.length);
    }, 4500);
    return () => clearInterval(interval);
  }, [featuredBlogs]);

  // Filter blogs by title
  const filteredBlogs = blogList.filter((b) =>
    b.title?.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <div className="blogs-wrap31">
      <Helmet>
        <title>
          Tamil Matrimony Blog | Marriage Tips, Love Stories & Tamil Wedding Culture
        </title>
        <meta
          name="description"
          content="Read Tamil Matrimony blogs on Varankal.com – wedding tips, success stories, and Tamil marriage culture insights. Perfect for brides, grooms, and families."
        />
        <meta
          name="keywords"
          content="Tamil Matrimony Blog, Tamil Wedding Tips, Marriage Advice, Tamil Culture Blog, Tamil Love Stories, Varankal Blog"
        />
      </Helmet>
      <div className="blogs-container31">
        {/* Header Section */}
        <div className="header-container31">
          <div className="title-section31">
            <h1 className="welcome31">
              <GiHeartInside className="icon31" /> Welcome to Matrimony Blogs
            </h1>
            <p className="subtitle31">
              Your destination for love stories, Tamil wedding tips, and cultural insights.
            </p>
          </div>

          <div className="search-bar31">
            <GiMagnifyingGlass className="search-icon31" />
            <input
              type="text"
              placeholder="Search..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </div>
        </div>

        {/* Featured Section */}
        <section className="featured-wrap31" aria-label="Featured blogs">
          {featuredBlogs.length > 0 && (
            <div className="featured-left31">
              <div className="featured-media31">
                <img
                  src={getImageSrc(featuredBlogs[currentSlide].image)}
                  alt={featuredBlogs[currentSlide].title}
                  className="featured-image31"
                />
              </div>
              <div className="featured-text31">
                <h2 className="featured-title31">
                  {featuredBlogs[currentSlide].title}
                </h2>
                <p className="featured-meta31">
                  <FaCalendarAlt className="meta-icon31" />{" "}
                  {new Date(featuredBlogs[currentSlide].date).toLocaleDateString()} &nbsp; | &nbsp;
                  <FaUserAlt className="meta-icon31" /> {featuredBlogs[currentSlide].author}
                </p>
              </div>
            </div>
          )}

          <aside className="featured-right31" aria-label="Other highlights">
            <div className="right-cards31">
              {sideBlogs.map((b) => (
                <article key={b._id} className="small-card31" tabIndex="0">
                  <img src={getImageSrc(b.image)} alt={b.title} />
                  <div className="small-card-body31">
                    <h4>{b.title}</h4>
                    <p className="meta31">
                      <FaCalendarAlt className="meta-icon31" />{" "}
                      {new Date(b.date).toLocaleDateString()}
                      <br />
                      <FaUserAlt className="meta-icon31" /> {b.author}
                    </p>
                  </div>
                </article>
              ))}
            </div>
          </aside>
        </section>

        {/* Blog List Section */}
        <section className="blog-list-wrap31">
          {filteredBlogs.map((blog) => (
            <article key={blog._id} className="blog-item31">
              <img src={getImageSrc(blog.image)} alt={blog.title} className="blog-thumb31" />
              <div className="blog-info31">
                <h3>{blog.title}</h3>
                <p className="meta31">
                  <FaCalendarAlt className="meta-icon31" />{" "}
                  {new Date(blog.date).toLocaleDateString()} &nbsp; | &nbsp;
                  <FaUserAlt className="meta-icon31" /> {blog.author}
                </p>
                <p className="content31">{blog.content}</p>
                <a href="#" className="readmore31">
                  Read More <FaArrowRight className="arrow-icon31" />
                </a>
              </div>
            </article>
          ))}
        </section>

        {/* Missed Blogs Section */}
        <section className="missed-section31" aria-label="You may have missed">
          <h2 className="missed-title31">
            <GiLoveMystery className="icon-love31" /> You May Have Missed
          </h2>
          <div className="missed-scroll31">
            {missedBlogs.map((m) => (
              <article key={m._id} className="missed-card31" tabIndex="0">
                <img src={getImageSrc(m.image)} alt={m.title} />
                <div className="missed-info31">
                  <h4>{m.title}</h4>
                  <p className="meta31">
                    <FaCalendarAlt className="meta-icon31" />{" "}
                    {new Date(m.date).toLocaleDateString()} &nbsp; | &nbsp;
                    <FaUserAlt className="meta-icon31" /> {m.author}
                  </p>
                </div>
              </article>
            ))}
          </div>
        </section>
      </div>
    </div>
  );
};

export default BlogsPage;
